import _Button from "antd/es/button";
import _Modal from "antd/es/modal";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _message from "antd/es/message";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var _dec, _class, _class2;
import React, { Component, useEffect, useState } from 'react';
import { formShape, createForm } from 'rc-form';
import { css } from 'emotion';
import sanitizeHtml from 'sanitize-html';
import styled from '@emotion/styled';
import isEqual from 'lodash/isEqual';
import Question from './Question';
import { Consumer } from '@/store';
import { getLocalText } from '../../utilities/language';
import { getFirstQuestionJump } from '../../utilities/quest';
var htmlReg = /<.*?>/g;
var onlyShowContent = window.location.href.includes('_dp_survey_only_content');
export default function Content() {
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    formRef = _useState2[0],
    handleFormRef = _useState2[1];
  useEffect(function () {
    formRef && formRef.resetValidateAll();
  }, [window.language]);
  var handleOnRef = function handleOnRef(ref) {
    handleFormRef(ref);
  };
  return React.createElement(Consumer, null, function (store) {
    var _store$state = store.state,
      answers = _store$state.answers,
      page = _store$state.page,
      allQuestions = _store$state.allQuestions,
      cipherUrl = _store$state.cipherUrl,
      quest = _store$state.quest;
    var _store$action = store.action,
      submit = _store$action.submit,
      getPageContent = _store$action.getPageContent,
      update = _store$action.update,
      backLastPage = _store$action.backLastPage,
      updateAnswers = _store$action.updateAnswers,
      emptyAllAnswers = _store$action.emptyAllAnswers;
    var _ref = quest || {},
      hideQuestionNo = _ref.hideQuestionNo,
      showQuestionType = _ref.showQuestionType,
      showLastPage = _ref.showLastPage,
      privacy = _ref.privacy,
      quotaStrategy = _ref.quotaStrategy,
      hidePageNo = _ref.hidePageNo;
    return React.createElement(Form, {
      answers: answers,
      cipherUrl: cipherUrl,
      emptyAllAnswers: emptyAllAnswers,
      updateAnswers: updateAnswers,
      privacy: privacy,
      page: page,
      formRef: formRef,
      handleOnRef: handleOnRef,
      doSubmit: submit,
      update: update,
      getPageContent: getPageContent,
      hideQuestionNo: hideQuestionNo,
      showQuestionType: showQuestionType,
      quotaStrategy: quotaStrategy,
      showLastPage: showLastPage,
      allQuestions: allQuestions,
      backLastPage: backLastPage,
      hidePageNo: hidePageNo
    });
  });
}
var Form = (_dec = createForm({
  onValuesChange: function onValuesChange(props, changed) {
    props.update(changed);
  }
}), _dec(_class = (_class2 = /*#__PURE__*/function (_Component) {
  _inherits(Form, _Component);
  function Form() {
    var _getPrototypeOf2;
    var _this;
    _classCallCheck(this, Form);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Form)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      submitStack: [],
      intervalID: null
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleTimeLimit", function (acCurrent) {
      var _this$props = _this.props,
        allQuestions = _this$props.allQuestions,
        current = _this$props.page.current;
      var _ref2 = allQuestions.filter(function (q) {
          return q.type === 'page_break';
        })[acCurrent ? acCurrent - 1 : current - 1] || {},
        timeLimit = _ref2.timeLimit;
      var _assertThisInitialize = _assertThisInitialized(_assertThisInitialized(_this)),
        timeRef = _assertThisInitialize.timeRef;
      if (timeLimit && _this.timeRef) {
        // eslint-disable-next-line
        var pageTimeLimit = function pageTimeLimit() {
          t--;
          timeRef.innerHTML = "(".concat(t, "s)");
          if (t <= 0) {
            clearInterval(intervalID);
            timeRef.innerHTML = '';
            that.setState({
              intervalID: null
            });
          }
        };
        var intervalID = window.setInterval(pageTimeLimit, 1000);
        _this.setState({
          intervalID: intervalID
        });
        var that = _assertThisInitialized(_assertThisInitialized(_this));
        var t = timeLimit;
      }
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "validateAllWithoutScroll", function (nextForm) {
      if (nextForm) {
        nextForm.validateFields({
          force: true
        });
        return;
      }
      var form = _this.props.form;
      form.validateFields({
        force: true
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "resetValidateAll", function (nextForm) {
      if (nextForm) {
        nextForm.resetFields();
        return;
      }
      var form = _this.props.form;
      form.resetFields();
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "submit", function (fields) {
      if (!_this.props.formRef) return;
      var _this$props2 = _this.props,
        form = _this$props2.form,
        doSubmit = _this$props2.doSubmit;
      var submitStep = [];
      form.validateFields(fields, {
        force: true
      }, /*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(error, value) {
          var key, element, submitPromise, hide;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!error) {
                    _context.next = 4;
                    break;
                  }
                  _this.setState({
                    submitStack: [getLocalText('Content.Form.error.message')]
                  });
                  try {
                    _message.error(getLocalText('Content.Form.error.message')); // '表单验证未通过');
                    key = Object.keys(error)[0];
                    element = document.getElementById(key);
                    element.scrollIntoView();
                    document.querySelector('body').scrollTop = element.offsetTop;
                    document.querySelector('html').scrollTop = element.offsetTop;
                  } catch (error) {
                    submitStep.push(error.message);
                  }
                  return _context.abrupt("return");
                case 4:
                  submitPromise = doSubmit(value);
                  if (submitPromise) {
                    _context.next = 7;
                    break;
                  }
                  return _context.abrupt("return");
                case 7:
                  hide = _message.loading(getLocalText('Content.Form.submitting'), 0); // '提交中...'
                  _context.next = 10;
                  return submitPromise.catch(function (err) {
                    submitStep.push("submit error: ".concat(err.message || '请求无结果'));
                  });
                case 10:
                  clearInterval(_this.state.intervalID);
                  _this.setState({
                    submitStack: submitStep,
                    intervalID: null
                  });
                  hide();
                case 13:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));
        return function (_x, _x2) {
          return _ref3.apply(this, arguments);
        };
      }());
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "goBackPage", function () {
      clearInterval(_this.state.intervalID);
      _this.setState({
        intervalID: null
      });
      if (_this.timeRef) {
        _this.timeRef.innerHTML = '';
      }
      _this.props.backLastPage();
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "emptyAllAnswers", function () {
      var _this$props3 = _this.props,
        emptyAllAnswers = _this$props3.emptyAllAnswers,
        form = _this$props3.form;
      form.resetFields();
      emptyAllAnswers();
    });
    return _this;
  }
  _createClass(Form, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.handleTimeLimit();
      var _this$props4 = this.props,
        privacy = _this$props4.privacy,
        handleOnRef = _this$props4.handleOnRef;
      handleOnRef(this);
      if ((privacy === null || privacy === void 0 ? void 0 : privacy.replace(htmlReg, '')) && !window.isReport) {
        _Modal.info({
          title: '',
          icon: null,
          width: 800,
          content: React.createElement("div", {
            style: {
              maxHeight: 600,
              overflow: 'auto',
              height: 'auto',
              textAlign: 'initial'
            },
            dangerouslySetInnerHTML: {
              __html: sanitizeHtml(privacy)
            }
          }),
          okText: getLocalText('Content.Form.Ok')
        });
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var quotaStrategy = nextProps.quotaStrategy,
        form = nextProps.form,
        current = nextProps.page.current;
      if (current > this.props.page.current) {
        this.handleTimeLimit(current);
      }
      if (!isEqual(this.props.quotaStrategy, quotaStrategy)) {
        this.validateAllWithoutScroll(form);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.handleOnRef(null);
      clearInterval(this.state.intervalID);
      this.setState = function () {
        return false;
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props5 = this.props,
        form = _this$props5.form,
        answers = _this$props5.answers,
        page = _this$props5.page,
        getPageContent = _this$props5.getPageContent,
        hideQuestionNo = _this$props5.hideQuestionNo,
        showQuestionType = _this$props5.showQuestionType,
        hidePageNo = _this$props5.hidePageNo,
        allQuestions = _this$props5.allQuestions,
        showLastPage = _this$props5.showLastPage,
        quotaStrategy = _this$props5.quotaStrategy,
        cipherUrl = _this$props5.cipherUrl;
      var _this$state = this.state,
        submitStack = _this$state.submitStack,
        intervalID = _this$state.intervalID;
      var _getPageContent = getPageContent(),
        no = _getPageContent.no,
        questions = _getPageContent.questions,
        isNextEnd = _getPageContent.isNextEnd;
      var breakPageInfo = questions.shift();
      var fields = questions.map(function (q) {
        return q.id;
      });
      var current = page.current,
        total = page.total;
      var firstQuestionJumpOver = getFirstQuestionJump({
        questions: questions
      });
      return React.createElement(ContentWrap, null, cipherUrl && React.createElement("div", {
        className: "flex",
        style: {
          position: 'fixed',
          top: 20,
          right: 20
        }
      }, React.createElement("input", {
        style: {
          opacity: 0,
          position: 'absolute'
        },
        id: "cipher-span",
        value: cipherUrl
      }), React.createElement(_Button, {
        type: "primary",
        className: "marginRight10",
        onClick: function onClick() {
          var el = document.querySelector('#cipher-span');
          el.focus();
          el.select();
          if (document.execCommand('copy')) {
            document.execCommand('copy');
            _message.success("\u94FE\u63A5\u590D\u5236\u6210\u529F, \u53EF\u76F4\u63A5\u53BB\u5BF9\u8BDD\u6846\u7C98\u8D34");
          }
          el.blur();
        }
      }, "\u751F\u6210"), React.createElement(_Button, {
        onClick: this.emptyAllAnswers
      }, "\u6E05\u7A7A\u7B54\u6848")), (breakPageInfo === null || breakPageInfo === void 0 ? void 0 : breakPageInfo.description) && React.createElement("div", {
        style: {
          padding: '40px 72px 60px 56px',
          background: 'white',
          marginBottom: 16,
          color: 'var(--text-color-secondary)',
          fontWeight: 350,
          display: !breakPageInfo.description ? 'none' : ''
        },
        dangerouslySetInnerHTML: {
          __html: sanitizeHtml(breakPageInfo.description)
        }
      }), React.createElement("form", {
        onSubmit: function onSubmit(e) {
          return e.preventDefault();
        }
      }, questions.reduce(function (_ref4, q) {
        var _ref5 = _slicedToArray(_ref4, 2),
          arr = _ref5[0],
          index = _ref5[1];
        arr.push(React.createElement(Question, {
          hideQuestionNo: hideQuestionNo,
          showQuestionType: showQuestionType,
          quotaStrategy: quotaStrategy === null || quotaStrategy === void 0 ? void 0 : quotaStrategy.find(function (s) {
            return s.questionId === q.id;
          }),
          questions: questions,
          allQuestions: allQuestions,
          answers: answers,
          form: form,
          key: q.id,
          no: index + no + 1,
          question: q,
          answer: answers[q.id]
        }));
        if (q.type === 'description') {
          return [arr, index];
        }
        return [arr, index + 1];
      }, [[], 0])[0]), !window.isReport && !onlyShowContent && React.createElement(React.Fragment, null, !hidePageNo && React.createElement("div", {
        className: "pageInfo",
        style: {
          display: total === 1 || current === 1 && firstQuestionJumpOver ? 'none' : ''
        }
      }, current, "/", total), React.createElement("div", {
        className: "flex alignCenter justifyBetween"
      }, current !== 1 && showLastPage && React.createElement(_Button, {
        size: "large",
        onClick: this.goBackPage,
        className: submitBtnCls,
        type: "primary"
      }, getLocalText('Content.Form.last.page') || 'Last'), React.createElement(_Button, {
        size: "large",
        onClick: function onClick() {
          return _this2.submit(fields);
        },
        className: submitBtnCls,
        disabled: intervalID,
        type: "primary"
      }, React.createElement("span", null, page.current === page.total && !isNextEnd ? getLocalText('Content.Form.submit') // '提交'
      : getLocalText('Content.Form.next.page') // '下一页'
      ), React.createElement("span", {
        className: "marginLeft10",
        ref: function ref(el) {
          _this2.timeRef = el;
        }
      }))), React.createElement("div", {
        className: "flex justifyCenter marginTop10 redColor"
      }, window.showErrorInfoAfterSubmitBtn && submitStack.join('=>'))));
    }
  }]);
  return Form;
}(Component), _defineProperty(_class2, "propTypes", {
  form: formShape
}), _class2)) || _class);
var ContentWrap = /*#__PURE__*/styled("section", {
  target: "ekqth220"
})("flex:1 0 auto;padding:0px;form{border:0;padding:0;background:transparent;}.pageInfo{font-size:14px;font-weight:normal;font-stretch:normal;font-style:normal;line-height:1.5;letter-spacing:0.2px;color:var(--text-color);text-align:center;margin-top:20px;}.ant-select-selection--single{height:48px;display:flex;align-items:center;}.ant-cascader-input{height:48px;background:var(--ant-border);}.ant-form-item-children{display:block;}.ant-cascader-picker:hover .ant-cascader-picker-clear{right:40px;}.ant-radio-group,.ant-radio-wrapper{display:block;color:var(--text-color);.description{margin-top:4px;font-size:12px;font-weight:350;font-stretch:normal;font-style:normal;line-height:1.5;letter-spacing:0.2px;color:var(--text-color-thirdly);}.ant-radio-inner::after{height:6px;width:6px;top:5px;left:5px;}.ant-radio-inner{height:18px;width:18px;top:-1px;}}.ant-radio-wrapper-checked .optionText{font-size:14px;font-weight:400;font-stretch:normal;font-style:normal;line-height:1.5;letter-spacing:0.2px;color:var(--primary-color);}.ant-checkbox-checked .ant-checkbox-inner::after{border:2px solid var(--ant-check-bg);border-top:0;border-left:0;height:9px;width:5px;left:30%;top:8px;transition:none;}.ant-checkbox-inner{height:19px;width:19px;border-radius:2px;background-color:var(--ant-bg);}.ant-checkbox-wrapper-checked:not(.isSingle) .ant-checkbox-inner{background:var(--primary-color);border-radius:2px;border:solid 1px var(--primary-color);transition:none;height:19px;width:19px;margin-right:0;}.ant-checkbox:hover::after,.ant-checkbox-wrapper:hover .ant-checkbox::after{visibility:hidden;}.ant-checkbox-wrapper{font-weight:normal;font-stretch:normal;font-style:normal;line-height:1.5;letter-spacing:0.2px;color:var(--text-color);display:flex;flex-flow:row nowrap;&.ant-checkbox-wrapper-checked{color:var(--primary-color);}.description{margin-top:4px;font-size:12px;font-weight:350;font-stretch:normal;font-style:normal;line-height:1.5;letter-spacing:0.2px;color:var(--text-color-thirdly);}}.ant-upload.ant-upload-drag{border-radius:4px;border:dashed 1px var(--border-gray);background-color:var(--bg-gray);margin-bottom:10px;}.max .ant-upload.ant-upload-drag{display:none;}.ant-form-explain{color:var(--text-red);position:absolute;width:100vw;top:-29px;left:0;z-index:2;padding:0px;transition:none;font-size:12px;line-height:1.5;}.ant-table-small{border:0;.ant-table-row:last-child td{border-bottom:1px solid var(--ant-table-border);}.ant-table-tbody > tr > td{padding:16px 8px !important;font-size:14px;line-height:1.57;}.ant-table-tbody > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td{background:var(--ant-table-hover);}}.optionText{display:flex;flex-flow:row wrap;.ant-input{border-color:var(--ant-border);&:focus,&:hover{border-color:var(--primary-color);}}}.ant-table-thead > tr > th{border-bottom-color:var(--ant-table-border);}.ant-table-tbody > tr > td{border-bottom-color:var(--ant-table-border);}.ant-cascader-picker-arrow{right:20px;}.ant-cascader-picker .ant-input{border-color:var(--ant-border);}.ant-calendar-picker.ant-calendar-picker-large{.ant-input-lg{height:48px;padding:6px 20px;}}.ant-input::-webkit-input-placeholder{font-weight:350;color:var(--text-color-thirdly);}");
var submitBtnCls = /*#__PURE__*/css("display:block;width:220px;height:40px;margin-left:auto;margin-top:30px;margin-right:auto;font-weight:normal;font-stretch:normal;font-style:normal;line-height:normal;letter-spacing:0.2px;color:#ffffff;");